export const SET_FOOD_CART = 'SET_FOOD_CART';
export const UPDATE_FOOD_LIST_CART = 'UPDATE_FOOD_LIST_CART';
export const CALCULATTING_CART = 'CALCULATTING_CART';
export const EMPTY_CART = 'EMPTY_CART';
export const FINAL_SUBMIT_CART = 'FINAL_SUBMIT_CART';
export const SET_EDIT_MODE_CART = 'SET_EDIT_MODE_CART';
export const RESET_FOOD_CART = 'RESET_FOOD_CART';
export const CHANGE_ADDRESS_CART = 'CHANGE_ADDRESS_CART';
export const RESET_CART = 'RESET_CART';
